import {
  BaseInput,
  BaseInputGroup,
  BaseSelect,
} from "@/components/input/CustomInputs";
import { Label } from "@/components/ui/label";
import { formInterface } from "@/interface/dataInterface";
import { Eye, EyeOff } from "lucide-react";
import { useState, FormEvent, FC } from "react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { handleFakeEventChange, handleFormChange } from "@/utils/formChange";
import { useUserContext } from "@/context/UserContext";

const DriverForm: FC<formInterface> = ({ mode, formProp, setFormProp }) => {
  const { decodedToken } = useUserContext();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="grid sm:grid-cols-2 place-items-center gap-4">
      <BaseInput
        id="firstname"
        label="First name"
        value={formProp.firstname}
        setProp={setFormProp}
        placeholder="First name"
      />
      <BaseInput
        id="lastname"
        label="Last name"
        value={formProp.lastname}
        setProp={setFormProp}
        placeholder="Last name"
      />
      <BaseInput
        id="email"
        label="Email"
        type="email"
        value={formProp.email}
        setProp={setFormProp}
      />
      <BaseInput
        id="phone"
        label="Phone number"
        value={formProp.phone}
        setProp={setFormProp}
        placeholder="+355 1234567"
      />
      <BaseSelect
        id="vehicle_id"
        resource="vehicles"
        dataProp="nickname"
        label="Vehicle"
        value={formProp.vehicle_id}
        setValue={setFormProp}
      />
      <BaseInput
        id="driver_license"
        placeholder="Driver license"
        label="Driver license"
        value={formProp.driver_license}
        setProp={setFormProp}
        required={false}
      />
      {mode === "create" && (
        <BaseInputGroup
          id="password"
          label="Password"
          type={showPassword ? "text" : "password"}
          value={formProp.password}
          setProp={setFormProp}
        >
          <div className="py-2">
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              className="cursor-pointer flex items-center justify-end pr-3"
            >
              {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
            </span>
          </div>
        </BaseInputGroup>
      )}
      {decodedToken?.settings.settings_type === "taxi" && (
        <div className="w-full">
          <Label>Can complete order</Label>
          <RadioGroup
            id="two_tanks"
            value={formProp.two_tanks}
            onValueChange={(value: string) =>
              handleFormChange(
                handleFakeEventChange(
                  "can_complete_order",
                  value,
                ) as FormEvent<any>,
                setFormProp,
              )
            }
            className="flex gap-2 mt-1"
          >
            {[
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ].map(({ value, label }) => {
              const isSelected = formProp.can_complete_order === value;
              return (
                <div key={value}>
                  <RadioGroupItem
                    value={value}
                    id={`two-tanks-${value}`}
                    className="peer hidden"
                  />
                  <Label
                    htmlFor={`two-tanks-${value}`}
                    className={`
                        px-4 py-2 rounded-md border text-sm font-medium cursor-pointer
                        ${isSelected ? "bg-white" : "bg-muted"} text-muted-foreground
                    `}
                  >
                    {label}
                  </Label>
                </div>
              );
            })}
          </RadioGroup>
        </div>
      )}
    </div>
  );
};

export default DriverForm;
